import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const LABELS = { qr_scan: "QR scans", ad_click: "Ad clicks", call_click: "Call taps", website_click: "Website", facebook_click: "Facebook",
  instagram_click: "Instagram", contact_form: "Messages", ai_chat: "AI chats" };

export function LeadStats({ business }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/my/businesses/${business.id}/lead-stats`).then(({ data }) => setD(data)).catch(() => {}); }, [business.id]);
  if (!d) return null;
  const rows = Object.entries(LABELS).map(([k, l]) => [k, l, d.events[k] || { total: 0, last_30_days: 0 }]);
  return (
    <div className="mt-4 rounded-xl border border-border bg-white p-4" data-testid={`lead-stats-${business.slug}`}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="font-display font-bold text-sam-navy text-sm">Leads from Saving America Money · last 30 days</div>
        {d.tier !== "max" && <Link to="/plans" className="text-xs font-semibold text-sam-crimson hover:underline" data-testid={`lead-stats-upgrade-${business.slug}`}>Upgrade to get more leads →</Link>}
      </div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2">
        {rows.map(([k, l, v]) => (
          <div key={k} className="rounded-lg bg-slate-50 border border-border p-2 text-center" data-testid={`lead-stat-${k}-${business.slug}`}>
            <div className="font-display text-lg font-black text-sam-navy">{v.last_30_days}</div>
            <div className="text-[10px] uppercase tracking-wide text-sam-slate">{l}</div>
            <div className="text-[10px] text-sam-slate/70">{v.total} all-time</div>
          </div>
        ))}
      </div>
      {d.recent_contacts?.length > 0 && (
        <div className="mt-3 space-y-1.5" data-testid={`lead-recent-${business.slug}`}>
          <div className="text-xs font-semibold text-sam-navy">Recent messages</div>
          {d.recent_contacts.map((c) => (
            <div key={c.at} className="text-xs rounded border border-border p-2 text-sam-slate">
              <b className="text-sam-navy">{c.contact?.name}</b> · {c.contact?.phone} {c.contact?.email} — {c.contact?.message}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
